import QueueRepository from "@/repositories/vns/QueueRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'queue',
    namespaced: true,
    state: {
        ...makeState(),
        realized: []
    },
    getters: {
        ...makeGetters(),
        allRealized (state) {
            return state.realized
        }
    },
    mutations: {
        ...makeMutations(),
        setAllRealized (state, array) {
            state.realized = array
        },
    },
    actions: {
        async service ({ commit }, params) {
            commit('setLoading', true)
            await QueueRepository.fetchService(params).then(response => {
                commit('setAll', response.data.data)
            })
            commit('setLoading', false)
        },
        async realized ({ commit }, params) {
            commit('setLoading', true)
            await QueueRepository.fetchRealized(params).then(response => {
                commit('setAllRealized', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
